module.exports = __webpack_public_path__ + "static/media/landingPageVideo1FR.3ea0ada7.webp";